<template>
  <div class="container-warp">
    <Top-Nav :pageTitle="paperTitle"
             :leftArrow="false"></Top-Nav>
    <!-- 顶部信息 -->
    <div class="top-info van-hairline--bottom">
      <div class="top-info-left">
        <span>已答题数：{{ answeredNum }}</span>
        (<span class="text-success">{{correctNum}}</span>/<span class="text-danger">{{errorNum}}</span>)
      </div>
      <div class="top-info-right">
        <span class="text-danger">已耗时：{{ elapsedTimeStr }}</span>
      </div>
    </div>
    <!-- 试题内容 -->
    <div class="main-content">
      <div class="bank-name">所属题库：{{bankName}}</div>
      <Question-item v-if="currentQuestionData"
                     :questionItem="currentQuestionData"
                     :questionTagOptions="questionTags"
                     :action="currentAction"></Question-item>
    </div>
    <!-- 底部功能区 -->
    <div class="bottom-func van-hairline--top">
      <div class="icon-btn"
           v-preventReClick="2000"
           @click="handleEndPractice(false)">
        <van-icon name="stop-circle-o"
                  size="36"
                  color="#ed5565" />
        <span class="icon-btn-text">结束练习</span>
      </div>
      <!-- <van-button type="danger"
                  icon="stop-circle-o"
                  class="bottom-func-btn"
                  @click="handleEndPractice(false)">结束练习</van-button> -->

      <van-button icon="passed"
                  type="info"
                  v-show="currentAction==='edit'"
                  class="bottom-func-btn"
                  v-preventReClick="1000"
                  @click="handleSubmitQuestion">提 交</van-button>
      <van-button icon="play-circle-o"
                  type="info"
                  v-show="currentAction==='submit'"
                  class="bottom-func-btn"
                  v-preventReClick="1000"
                  @click="handleNextQuestion">下一题</van-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getQuestion, endExercise, getMistakesQuestion, endMistakeExercise } from "@/api/examQuestionBank";
import funcDialog from "@/components/BaseFuncDialog/funcDialog";
import QuestionItem from "@/components/QuestionItem/QuestionItem.vue";
export default {
  name: 'DoPracticeQuestions',
  components: { QuestionItem },
  data() {
    return {
      routeName: '', // DoPracticeQuestions-抽题练习；DoPracticeMistakesQuestions-错题练习
      paperTitle: '抽题练习',
      bankName: '测试题库',
      elapsedTime: 0, // 已耗时间。秒
      elapsedTimeStr: '00时00分00秒', // 已耗时间。需处理为时分秒
      answeredNum: 0, // 已答题数
      correctNum: 0, // 正确数
      errorNum: 0, // 错误数
      currentQuestionData: null,
      currentAction: 'edit', // 操作。edit-编辑；submit-提交；view-查看
      questionTagOptions: [],
      questionIds: [], // 已答题试题id列表
      wrongQuestionIds: [], // 错题id列表
      correctQuestionIds: [], // 正确题id列表
      bankIds: []
    }
  },
  computed: {
    ...mapGetters(['questionTags']),
  },
  created() {
    this.handleBeforePractice();
  },
  beforeDestroy() {
    this.endTimer();
  },
  methods: {
    // 处理开始练习前的逻辑
    handleBeforePractice() {
      this.routeName = this.$route.name;
      // 如果是抽题练习，先弹出显示选择题库范围
      if (this.routeName === 'DoPracticeQuestions') {
        this.paperTitle = '抽题练习';
        this.openSelectBankDialog()
      } else {
        this.paperTitle = '错题练习';
        this.handletBeginPractice()
      }
    },
    // 获取试题数据
    async getQuestionData() {
      const { routeName, bankIds } = this
      const params = {
        questionIds: [...this.questionIds]
      }
      if (routeName === 'DoPracticeQuestions') {
        params.bankIds = bankIds
      }
      const { status, data } = routeName === 'DoPracticeQuestions' ? await getQuestion(params) : await getMistakesQuestion(params)
      if (status == 200 && data) {
        const questionData = { ...data }
        questionData.answer = {
          answerResult: 0,
          stuAnswer: [2, 4].includes(questionData.questionType) ? [] : '' // 多选题、填空题处理为数组
        }
        this.currentAction = 'edit'
        this.bankName = questionData.bankName || ''
        this.currentQuestionData = questionData
      } else { // 无试题情况
        this.handleEndPractice(true)
      }
    },
    // 开始练习
    handletBeginPractice() {
      this.getQuestionData()
      this.startTimer();
    },
    // 打开选择抽题范围弹窗
    async openSelectBankDialog() {
      try {
        const cbParams = await funcDialog({
          title: '选择抽题范围',
          dialogAttributes: {
            width: '100%',
            height: '86%',
            position: 'bottom',
            closeable: true,
            closeOnClickOverlay: false
          },
          contentComponent: () => import('./components/select-question-bank.vue'), // 懒加载组件
          dialogParams: { test: 1 },
        })
        // 确认选择回调
        console.log(cbParams,'cbParams')
        this.bankIds = cbParams.bankIds
        this.handletBeginPractice()
      } catch (cbParams) {
        // this.$router.push({ path: '/index' })
        this.$router.replace('/index')
        console.log(cbParams)

      }
    },
    // 提交。和正确答案判断是否正确
    handleSubmitQuestion() {
      // console.log(this.currentQuestionData)
      const { answer, correct, questionType } = this.currentQuestionData
      let currentStuAnswer = answer.stuAnswer

      // 如果是多选题，答案为数组，对数组进行字符串排序
      if (questionType == 2) {
        answer.stuAnswer.sort()
        currentStuAnswer = answer.stuAnswer.join(',')
      }

      // 对比答案
      if (currentStuAnswer === correct) {
        this.currentQuestionData.answer.answerResult = 1 // 正确
        this.correctNum++ // 正确数量+1
        this.correctQuestionIds.push(this.currentQuestionData.id)
      } else {
        this.currentQuestionData.answer.answerResult = 2 // 错误
        this.errorNum++ // 错误数量+1
        this.wrongQuestionIds.push(this.currentQuestionData.id)
      }
      this.answeredNum++ // 总数量+1
      this.questionIds.push(this.currentQuestionData.id)
      this.currentAction = 'submit' // 切换为提交状态
    },
    // 下一题
    handleNextQuestion() {
      this.getQuestionData()
    },
    // 结束练习
    handleEndPractice(noQuestion = false) {
      const msg = noQuestion ? '已完成所有练习试题，本次练习结束！' : '是否结束本次练习？'
      this.$dialog({
        title: '提示',
        showClose: !noQuestion,
        message: msg,
        showCancelButton: !noQuestion,
        closeOnClickOverlay: false
      }).then(async () => {
        const { routeName, elapsedTime, answeredNum, correctNum, errorNum, wrongQuestionIds, correctQuestionIds } = this;
        const params = {
          "duration": elapsedTime,
          "answerTotal": answeredNum,
          "correctNum": correctNum,
          "mistakeNum": errorNum,
          "correctList": [...correctQuestionIds],
          "mistakeList": [...wrongQuestionIds]
        }
        const { status } = routeName === 'DoPracticeQuestions' ? await endExercise(params) : await endMistakeExercise(params)
        if (status == 200) {
          this.endTimer();
          this.pageBack()
        }
      })
    },
    // 计时开始    
    startTimer() {
      if (this.timer) {
        clearInterval(this.timer);
      }
      this.timer = setInterval(() => {
        this.elapsedTime++;
        this.formatElapsedTime();
      }, 1000);
    },
    // 计时结束
    endTimer() {
      clearInterval(this.timer);
    },
    // 格式化已耗时间
    formatElapsedTime() {
      const h = Math.floor(this.elapsedTime / 3600);
      const m = Math.floor(this.elapsedTime % 3600 / 60);
      const s = Math.floor(this.elapsedTime % 60);
      this.elapsedTimeStr = `${h < 10 ? '0' + h : h}时${m < 10 ? '0' + m : m}分${s < 10 ? '0' + s : s}秒`;
    },
  },
}
</script>

<style lang="less" scoped>
.container-warp {
  background-color: #fff;
}
.top-info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 39px;
  box-sizing: border-box;
  padding: 0 12px;
  font-size: 14px;
}
.main-content {
  padding: 12px 12px 56px 12px;
  box-sizing: border-box;
  background-color: #fff;
  .bank-name {
    font-size: 14px;
    color: #ccc;
    text-align: center;
    margin-bottom: 10px;
  }
}
.bottom-func {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 56px;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 12px;
  box-sizing: border-box;
  .icon-btn {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    color: #ed5565;
    .icon-btn-text {
      margin-top: 0;
    }
  }
  .bottom-func-btn {
    height: 36px;
    line-height: 36px;
  }
}
</style>